// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"585":"f9fb28cd","832":"3abb64d2"}[chunkId] + ".chunk.js";
};